import updatePartnerHomepage from '../../../../actions/siteadmin/PartnerHomepage/updatePartnerHomepage'

async function submit(values, dispatch) {
    await dispatch(updatePartnerHomepage(values))
}

export default submit;